import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateEvent($data: CreateEventInput!) {
    createEvent(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createEvent: {
    id: number;
  };
}
